import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { AuthService } from '../../../../core/auth/services/auth.service';
import { Router } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'patient-hydration-card',
  standalone: true,
  imports: [CommonModule, NgFor, NgIf, DropdownModule, FormsModule],
  templateUrl: './hydration-card.component.html',
  styleUrl: './hydration-card.component.css',
})
export class HydrationCardComponent {
  @Input() hydrationData: any;
  @Output() hydrationUpdated = new EventEmitter<void>();

  private dashboardService = inject(DashboardService);
  private authService = inject(AuthService);
  private router = inject(Router);

  intakeOptions = [
    { label: '200 ml', value: 200 },
    { label: '250 ml', value: 250 },
    { label: '300 ml', value: 300 },
    { label: '400 ml', value: 400 },
    { label: '500 ml', value: 500 },
  ];
  selectedIntake: number = 200;

  get intake(): number {
    return this.hydrationData?.todays_intake || 0;
  }
  get goal(): number {
    return this.hydrationData?.todays_goal || 2000;
  }
  get avg(): number {
    return this.hydrationData?.weekly_avg || 0;
  }
  get weeklyGoalPercent(): number {
    return this.hydrationData?.weekly_avg || 0;
  }

  get progress(): number {
    return Math.min(Math.round((this.intake / this.goal) * 100), 100);
  }

  get percentage(): number {
    return Math.round((this.intake / this.goal) * 100);
  }

  get remainingLabel(): string {
    const rem = Math.max(0, (this.goal - this.intake) / 1000);
    return rem > 0 ? `${rem.toFixed(1)}L left to reach today's goal` : 'Goal reached!';
  }

  formatMlToL(ml: number): string {
    return (ml / 1000).toFixed(1);
  }

  getGlassFill(index: number): number {
    const totalGlasses = 5;
    const ratio = this.intake / this.goal;
    // Each glass represents 20% of the goal
    const fill = ratio * totalGlasses - index;
    return Math.max(0, Math.min(1, fill));
  }

  increment() {
    this.logHydration(this.selectedIntake);
  }

  decrement() {
    if (this.intake >= this.selectedIntake) {
      this.logHydration(-this.selectedIntake);
    } else if (this.intake > 0) {
      this.logHydration(-this.intake);
    }
  }

  navigateToTrends() {
    console.log(this.hydrationData.tracting_id, 'treacking id insise card');

    // this.router.navigate(['/hydration-details', {state: { tracking_id: this.hydrationData?.tracking_id }}]);
    this.router.navigateByUrl('/hydration-details', {
      state: { tracking_id: this.hydrationData?.tracting_id },
    });
  }

  private logHydration(amount: number) {
    this.authService.getUserProfile().subscribe((user) => {
      if (user?.PatientId) {
        const payload = {
          patient_id: user.PatientId,
          tracking_id: this.hydrationData?.tracting_id || user.PatientId,
          amount_ml: amount,
          log_source: 1,
          log_date: new Date().toISOString().split('T')[0],
        };
        this.dashboardService.logHydration(payload).subscribe({
          next: () => this.hydrationUpdated.emit(),
          error: (err) => console.error('Error logging hydration', err),
        });
      }
    });
  }
}
